import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const navLinks = [{
    name: 'Home',
    href: '#/'
  }, {
    name: 'System Types',
    href: '#/system-types'
  }, {
    name: 'Materials',
    href: '#/materials'
  }, {
    name: 'Finishes',
    href: '#/concrete-finishes'
  }, {
    name: 'Installation',
    href: '#/installation-process'
  }];
  return <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60" data-id="element-340">
      <div className="container mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-341">
        {/* Logo */}
        <a href="#/" className="flex items-center gap-2" data-id="element-342">
          <img src="https://cdn.magicpatterns.com/uploads/1Stki6WQT8fun4qYjVmCAY/sunflow-primary-logo-full-color-rgb-900px-w-72ppi.png" alt="SunFlow Heated Driveways" className="h-10 w-auto" data-id="element-343" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-344">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-primary transition-colors" data-id="element-345">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-4" data-id="element-346">
          <a href="tel:647-706-9908" className="flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-primary transition-colors" data-id="element-347">
            <Phone className="h-4 w-4" data-id="element-348" />
            (647) 706-9908
          </a>
          <Button onClick={() => {
          const quoteForm = document.getElementById('quote-form');
          if (quoteForm) {
            quoteForm.scrollIntoView({
              behavior: 'smooth'
            });
          } else {
            window.location.href = '#/';
            setTimeout(() => {
              document.getElementById('quote-form')?.scrollIntoView({
                behavior: 'smooth'
              });
            }, 300);
          }
        }} data-id="element-349">
            Get Quote
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-slate-600" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-350">
          {isMenuOpen ? <X className="h-6 w-6" data-id="element-351" /> : <Menu className="h-6 w-6" data-id="element-352" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden border-t bg-white p-4 space-y-4 animate-in slide-in-from-top-5" data-id="element-353">
          <nav className="flex flex-col gap-4" data-id="element-354">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-600 hover:text-primary" onClick={() => setIsMenuOpen(false)} data-id="element-355">
                {link.name}
              </a>)}
            <hr className="border-slate-100" data-id="element-356" />
            <a href="tel:647-706-9908" className="flex items-center gap-2 text-base font-medium text-slate-600" data-id="element-357">
              <Phone className="h-4 w-4" data-id="element-358" />
              (647) 706-9908
            </a>
            <Button fullWidth onClick={() => {
          setIsMenuOpen(false);
          const quoteForm = document.getElementById('quote-form');
          if (quoteForm) {
            quoteForm.scrollIntoView({
              behavior: 'smooth'
            });
          } else {
            window.location.href = '#/';
            setTimeout(() => {
              document.getElementById('quote-form')?.scrollIntoView({
                behavior: 'smooth'
              });
            }, 300);
          }
        }} data-id="element-359">
              Get Quote
            </Button>
          </nav>
        </div>}
    </header>;
}